import { IsUUID } from 'class-validator';

/** Aggiunge manualmente un cliente dell'anagrafica come parte da avvisare. */
export class AddRecallPartyDto {
  @IsUUID()
  customerId!: string;
}
